import { render, staticRenderFns } from "./componentList.vue?vue&type=template&id=3016ca42&scoped=true&"
import script from "./componentList.vue?vue&type=script&lang=js&"
export * from "./componentList.vue?vue&type=script&lang=js&"
import style0 from "./componentList.vue?vue&type=style&index=0&id=3016ca42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3016ca42",
  null
  
)

export default component.exports